module.exports = __webpack_public_path__ + "static/quiz_tv_set-619f98eaf21f8a140e0d4c2be6c8f7ae.jpg";